import { IAccordionListNode } from '@opengov/component-library/capital/AccordionList/AccordionList';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import React from 'react';

import { IPublicationCustomCssMessages } from '../../../../../types';
import { FolderTreeSelect } from '../../../CommonComponents/FolderTreeSelect/FolderTreeSelect';

import { styles } from './Header.styles';

export type IHeaderProps = {
  isLoading: boolean;
  isApplying: boolean;
  messages: IPublicationCustomCssMessages;
  storiesSelectData: IAccordionListNode[];
  selectedStoryId: string;
  publicationTitle: string;
  onStoryChange(storyId: string): void;
  onExit(): void;
};

export const Header = (props: IHeaderProps) => {
  const {
    isApplying,
    isLoading,
    messages,
    publicationTitle,
    storiesSelectData,
    selectedStoryId,
    onStoryChange,
    onExit
  } = props;

  return (
    <Box component="header" sx={styles.container}>
      <Box sx={styles.primaryRow}>
        <Box>
          <Typography variant="h2">{messages.customCss}</Typography>
          <Typography variant="body2" color="text.secondary">
            {messages.publication}: {publicationTitle}
          </Typography>
        </Box>
        <Button
          variant="contained"
          color="primary"
          disabled={isApplying}
          onClick={onExit}
          data-test="exitButton"
        >
          {messages.exit}
        </Button>
      </Box>
      <Box sx={styles.secondaryRow}>
        <Typography variant="body2" color="text.secondary">
          {messages.showingStory}
        </Typography>
        <Box sx={styles.storySelectContainer}>
          <FolderTreeSelect
            activeNodeId={selectedStoryId}
            data={storiesSelectData}
            dataTest="stories-accordion-select"
            disabled={isLoading || isApplying}
            maxMenuHeight={400}
            onNodeSelect={(node) => onStoryChange(node.id)}
            showDisabledStyle={false}
            showFilter={true}
          />
        </Box>
      </Box>
    </Box>
  );
};
